'use client';

import React from "react";
import SecondaryTag from "../../Tags/SecondaryTag";
import AccordionLayout from "./AccordionLayout";

const superAdmin = "/assets/dcc/super-admin.png";
const modules = "/assets/dcc/modules.png";
const company = "/assets/dcc/company.png";
const stats = "/assets/dcc/stats.png";
const frontSite = "/assets/dcc/front-site.png";
const accordionData = [
  {
    title: "Super Admin Dashboard",
    data: [
      {
        question: "Key Metrics Overview",
        answer: [
          "Total, active, and inactive companies.",
          "Recently registered and license-expired companies.",
          "Support ticket and offline request monitoring.",
        ],
      },
      {
        question: "Admin Controls",
        answer: [
          "Create custom roles (e.g., admin, manager, editor, viewer) with specific permissions..",
          "Restrict access to specific projects, tasks, or data based on user roles.",
        ],
      },
      {
        question: "Data Management",
        answer: [
          "Define custom metadata fields for content or projects to improve searchability and organization.",
        ],
      },
      {
        question: "Customization Options",
        answer: [
          "Predefine task structures for recurring projects.",
          "Customize user permissions and access levels for different team members.",
        ],
      },
    ],
    image: superAdmin,
  },
  {
    title: "Modules",
    data: [
      {
        question: "Human Resource",
        answer: [
          "Employee attendance, leaves, holidays, and notices.",
          "Track employment history, skills, and certifications.",
        ],
      },
      {
        question: "CRM",
        answer: [
          "Store and manage customer contact information (e.g., names, emails, phone numbers) in a centralized system.",
          "Assign scores to leads based on their engagement and likelihood to convert.",
        ],
      },
      {
        question: "Project Management",
        answer: [
          "Enable seamless communication with integrated messaging and file-sharing features.",
          "Gain insights with dashboards, analytics, and reports to track performance.",
        ],
      },
      {
        question: "ERP (Enterprise Resource Planning)",
        answer: [
          "Store and manage essential business data in a unified system for better decision-making.",
        ],
      },
      {
        question: "Support Services",
        answer: [
          "Get round-the-clock support via live chat, email, and phone.",
          "Quick resolution of system issues, bugs, or performance concerns.",
        ],
      },
    ],
    image: modules,
  },
  {
    title: "Company Management",
    data: [
      {
        question: "Impersonation",
        answer: [
          "Admins can troubleshoot and configure company settings.",
          "Simulate different user experiences to verify settings and permissions.",
        ],
      },
      {
        question: "Client Package Management",
        answer: [
          "Track client subscriptions, renewal dates, and plan upgrades or downgrades.",
          "Track client activity, resource utilization, and service performance.",
        ],
      },
      {
        question: "Contact Details",
        answer: [
          "Monday – Friday: 9:00 AM – 6:00 PM (Your Timezone)",
          "Saturday – Sunday: Limited Support Available",
        ],
      },
    ],
    image: company,
  },
  {
    title: "Statistics and Usage",
    data: [
      {
        question: "Key Metrics",
        answer: [
          "Employees, storage, clients, invoices, estimates, projects, tasks, leads, orders, and tickets.",
          "Gain actionable insights to improve operations.",
        ],
      },
      {
        question: "Actionable Insights",
        answer: [
          "Gain clear, data-backed recommendations.",
          "Address issues before they impact user experience.",
        ],
      },
    ],
    image: stats,
  },
  {
    title: "Front Site Customization",
    data: [
      {
        question: "Themes",
        answer: [
          "Multiple themes for personalization.",
          "Offer users the flexibility to switch between dark and light modes based on their preferences.",
        ],
      },
      {
        question: "Testimonials and FAQs",
        answer: [
          "Enable users to search for specific topics and find relevant answers quickly.",
          "Offer FAQ translations to cater to a global audience.",
        ],
      },
      {
        question: "SEO and Social Links",
        answer: [
          "Link to social media accounts like Facebook, Twitter, LinkedIn, Instagram, YouTube, and more.",
          "Display live feeds from your social media accounts directly on your platform or website.",
        ],
      },
      {
        question: "Custom Scripts",
        answer: [
          "Connect third-party APIs to enhance platform capabilities, such as payment gateways, CRM systems, and more.",
          "Add widgets or plugins that enhance functionality, such as live chat, analytics, or calendar tools.",
        ],
      },
    ],
    image: frontSite,
  },
];

function Features() {
  return (
    <div className="max-w-screen-2xl mx-auto">
      <div className="flex flex-col items-center gap-2 lg:mt-28">
        <SecondaryTag text="Features" />
        <div className="w-[300px] md:w-[696px] text-color-1 text-center text-4xl lg:text-[56px] font-medium leading-[normal] lg:mb-16">
          Built For Excellence
        </div>
      </div>
      {/* accordation */}
      <div className="space-y-[66px] mx-2 md:mx-16">
        {accordionData.map(({ title, data, image }, i) => (
          <AccordionLayout
            key={i}
            title={title}
            accordionData={data}
            defaultOpenIndex={0}
            images={image}
            isEven={i % 2 === 0}
          />
        ))}
      </div>

      <div className="absolute top-10 -left-80 rounded-full w-[500px] h-[500px] bg-[radial-gradient(circle,_var(--accent-light),_var(--accent-dark))] blur-3xl opacity-10"></div>
      <div className="absolute top-10 -right-80 rounded-full w-[500px] h-[500px] bg-[radial-gradient(circle,_var(--accent-light),_var(--accent-dark))] blur-3xl opacity-10"></div>

      <div className="absolute top-[1000px] -left-80 rounded-full w-[500px] h-[500px] bg-[radial-gradient(circle,_var(--accent-light),_var(--accent-dark))] blur-3xl opacity-10"></div>
      <div className="absolute top-[1000px] -right-80 rounded-full w-[500px] h-[500px] bg-[radial-gradient(circle,_var(--accent-light),_var(--accent-dark))] blur-3xl opacity-10"></div>

      <div className="absolute top-[1800px] -left-80 rounded-full w-[500px] h-[500px] bg-[radial-gradient(circle,_var(--accent-light),_var(--accent-dark))] blur-3xl opacity-10"></div>
      <div className="absolute top-[1800px] -right-80 rounded-full w-[500px] h-[500px] bg-[radial-gradient(circle,_var(--accent-light),_var(--accent-dark))] blur-3xl opacity-10"></div>
    </div>
  );
}

export default Features;
